export const JobNotificationValidation = (formData) => {
    const errors = {};

    if (!formData.vc_Name || !formData.vc_Name.trim()) {
        errors.vc_Name = 'This field is required';
    }
    if (!formData.vc_Email || !formData.vc_Email.trim()) {
        errors.vc_Email = 'This field is required';
    }
    return errors;
};
